// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__30VFM","additionalInfo":"AgreementModal_additionalInfo__2dWGO"};